import React from 'react'
import { Page, Document, pdfjs } from 'react-pdf/dist/esm/entry.webpack5'
import { useWindowWidth } from '@wojtekmaj/react-hooks'

const PdfClient = ({ url }) => {
  const width = useWindowWidth()

  if (typeof window !== 'undefined') {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`,
      import.meta.url,
    )
  }

  return (
    <Document file={url}>
      <Page
        pageNumber={1}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        width={Math.min(width * 0.9, 1260)}
      />
    </Document>
  )
}

export default PdfClient
